import classNames from 'classnames';
import * as React from 'react';

export interface BaseLinkProps {
  href: string;
  className?: string;
  type: 'default' | 'button'
  buttonSize?: 'small' | 'medium' | 'large';
  buttonType?: 'solid' | 'underline' | 'clear';
  buttonTier?: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
}

interface LinkWithLabel extends BaseLinkProps {
  label: string;
}

interface LinkWithChildren extends BaseLinkProps {
  children: React.ReactNode;
}

export type LinkProps = (LinkWithChildren | LinkWithLabel) &
  Pick<
    React.LinkHTMLAttributes<HTMLLinkElement>,
    | 'aria-selected'
    | 'aria-controls'
    | 'aria-expanded'
    | 'role'
    | 'aria-haspopup'
    | 'aria-describedby'
    | 'aria-label'
    | 'tabIndex'
  >;

export const Link: React.FC<LinkProps> = props => {
  const elementToRender = 'children' in props && props.children ? props.children : 'label' in props && props.label;

  const {
    href,
    tabIndex,
    className,
    type = 'default',
    buttonType = 'solid',
    buttonTier = 'primary',
    buttonSize = 'large',
    ...additionalProps
  } = props;

  const getLinkClassName = () => {
    if (type === 'button') {
      return classNames(
        'insuranceLink',
        'insuranceLink--button',
        'insuranceButton', {
          'insuranceButton--small': buttonSize == 'small',
          'insuranceButton--medium': buttonSize == 'medium',
          'insuranceButton--large': buttonSize == 'large',
          'insuranceButton--solid': buttonType == 'solid',
          'insuranceButton--underline': buttonType == 'underline',
          'insuranceButton--clear': buttonType == 'clear',
          'insuranceButton--primary': buttonTier == 'primary',
          'insuranceButton--secondary': buttonTier == 'secondary',
          'insuranceButton--tertiary': buttonTier == 'tertiary',
          'insuranceButton--quaternary': buttonTier == 'quaternary',
        },
        className
      );
    }
    return classNames('insuranceLink', `insuranceLink--default`, className);
  };

  return (
    <a
      {...additionalProps}
      tabIndex={tabIndex}
      href={href}
      className={getLinkClassName()}
    >
      <div className="insuranceLink__label">{elementToRender}</div>
    </a>
  );
};
